///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/brand.js
///include /assets/js/app/p/sbproduct/all.js

"use strict"

class SOrderAdditionalServicesPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "additional-services",
            data() {
                return {
                    /** @type {SBasket} */
                    ///@ts-ignore
                    basket: AnyBasket.inst,
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    format: Site.Format,
                    /**
                     * @type {SBHostingProduct | boolean | null}
                     */
                    queryProduct: null,
                    settings: SharedSettings.inst,
                    translation: translation,
                }
            },
            computed: {
                loading() {
                    return !(
                        this.catalogue.products &&
                        this.catalogue.isOpen !== null
                    );
                },
                /**
                 * @type {SBHostingProduct[]}
                 */
                products() {
                    if(this.catalogue.products) {
                        //@ts-ignore
                        return this.catalogue.products.filter(
                            p => p instanceof SBCustomProduct && p.forSale
                        )
                    } else {
                        return []
                    }
                },
                pageQuery() {
                    const query = window.location.search.substr(1).split('&')

                    if (!query) return null

                    /**
                     * @type {{ type: string, code: string }}
                     */
                    const queryObj = query.reduce((result, q) => {
                        const qParts = q.split('=')
                        result[qParts[0]] = qParts[1]
                        return result
                    }, {})

                    return { query, queryObj }
                },
                customProducts() {
                    return this.products.filter(p => (
                        !p.isHidden ||
                        p === this.queryProduct
                    ))
                },
                contact() {
                    return this.settings.contact;
                },
                loggedIn() {
                    return !!this.settings.authenticatedUser;
                },
            },
            watch: {
                loading(v) {
                    if (!v) {
                        Vue.nextTick(() => {
                            $(".page-loaded-content").fadeTo(200, 1, function() {});
                        });
                    }
                }
            },
            methods: {
                async addCustomProductToBasket(customProduct) {
                    const prices = customProduct.pricing;
                    const pic = PaymentItemCollection.inst
                    const affiliate = getCookie("affiliate")
                    await this.catalogue.preload([
                        "config",
                        "userVATRate"
                    ])
                    await this.basket.addWithInfo(
                        {
                            paymentItemCountries:
                                await pic.preloadSingle("countriesFlat"),
                            affiliateCode: affiliate
                        },
                        await customProduct.basketItem(
                            prices[0],
                            null,
                            1,
                            null
                        ),
                    )
                    setTimeout(() => {
                        if(this.loggedIn) {
                            location.href = "/checkout"
                        } else {
                            location.href = "/basket-summary-login?r=/checkout"
                        }
                    }, 300) // Work around HTTP2 offloading x firefox
                },

                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    return Catalogue.intervalMonthsLabel(m)
                },
            },

            components: {
                shopNav: ShopNav,
            },

            mounted() {
                this.catalogue.assertExists()

                if (!this.pageQuery) return

                const { code } = this.pageQuery.queryObj

                if (code) {
                    const queryProduct = this.products.find(p => p.code === code)
                    if (!queryProduct) return this.queryProduct = false

                    this.queryProduct = queryProduct
                }
            },
        })
    }
}
